/**
 *  @module geo/functionalities
 */


import {Observable} from 'rxjs/Observable';
import {isUndefined} from 'util';

import {SearchService} from '../services/search';
import {FilterContext, FilterValue} from '../types/functionality';

import {Functionality} from '.';
import {FunctionalityService} from './services';
import {SearchFunctionalityService} from './services/search';

export class SearchExecutionParameters {
  /**
   * list of filters to apply
   */
  filters?: FilterValue[];
  /**
   * limit the number of results to return, if not setted, configuration from
   * geo will be used
   *
   */
  queryLimit?: number;
  /**
   * string for limiting query, can be set to null, or string "view", to limit
   * filter to the current view, or an [[Extent]] object
   *
   */
  spatialFilter?: any;
  /**
   * text to display in filters panel
   */
  filtersLabel?: string;
  /**
   * Special context to apply on filter. Like a features of elements for
   * intersection
   */
  filterContext?: FilterContext;

  /**
   * to execute search on unique feature by id
   */
  featureId?: any;
  /**
   * "Output coordinate system SRID
   */
  srid?:string;

  throwError?:boolean
}

/**
 * A search functionality, see  method execute.
 *
 * For instance:
 *
 *
 * - to search datas contained in a features :
 *
 * ```
 *    geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute(
 * {
 *     filterContext: {
 *         featureSelectionFilter :{
 *           "coordinateSystem": { "srid": 3857,},
 *            "filter": "CONTAINED",
 *            "features": [{ "id": "11","layerKey":
 * "52344c8f-d789-11e7-8ae0-0921000796c6!g"}],
 *         }
 *     }
 *    }
 * );
 * ```
 *
 * - to search datas with a a specfic filter:
 *
 * ```javascript
 *    geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute(
 * {
 *       "filters":
 *             [
 *               {"name":"rowidsupp","values":[300]},
 *               {"name":"rowidinf","values":[350]}
 *             ]
 *    }
 * );
 * ```
 */
export class SearchFunctionality extends Functionality {
  getService(): SearchFunctionalityService|void {
    if (isUndefined(this.store)) {
      throw new Error('no store defined for functionality');
    }
    if (!this.service) {
      const options = {
        store: this.store
      }

                      this.service =
          new SearchFunctionalityService(this, options) as
          FunctionalityService<SearchFunctionality, SearchService>;
    }
    return this.service;
  }

  public static typeDef = 'com.bg.functionality.search.Search';

  /**
   * Execute a search, with given parameters
   * For example
   *
   * - to search datas contained in a features :
   * ```
   *    geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute(
   * {
   *     filterContext: {
   *         featureSelectionFilter :{
   *           "coordinateSystem": { "srid": 3857,},
   *            "filter": "CONTAINED",
   *           "features": [{ "id": "11","layerKey":
   * "52344c8f-d789-11e7-8ae0-0921000796c6!g"}],
   *         }
   *     }
   *    }
   * );
   * ```
   *
   * - to search datas with a filter:
   * ```
   *    geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute(
   * {
   *       "filters":
   *             [
   *               {"name":"rowidsupp","values":[300]},
   *               {"name":"rowidinf","values":[350]}
   *             ]
   *    }
   * );
   * ```
   *
   *
   *
   *
   * @param parameters
   * @returns {Observable<any>}
   */
  public execute(parameters: SearchExecutionParameters): Observable<any> {
    return super.execute(parameters);
  }
}